import createAction from 'redux-actions/es/createAction';

export const validateMfaInputRequest = createAction('VALIDATE_MFA_INPUT_REQUEST');
export const validateMfaInputSuccess = createAction('VALIDATE_MFA_INPUT_SUCCESS');
export const validateMfaInputFail = createAction('VALIDATE_MFA_INPUT_FAIL');
